import React from "react";
import { Space, Typography } from "@payping/web-components";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { IBANItem, IBANStatus } from "../types";
import ShebaCard from "./ShebaCard";

interface PendingIBANsSectionProps {
  pendingIBANs: IBANItem[];
  onEditIBAN: (ibanId: string) => void;
  onRemoveIBAN?: (ibanId: string) => void;
  getStatusInfo: (status: IBANStatus) => { color: string; text: string; icon: React.ReactNode };
  onRetryRejected: () => Promise<any>;
  retryRequestLoading: boolean;
  activeIBAN?: string | null;
}

export const PendingIBANsSection: React.FC<PendingIBANsSectionProps> = ({
  pendingIBANs,
  onRemoveIBAN: handleRemoveIBAN,
  getStatusInfo,
  onRetryRejected,
  retryRequestLoading,
  activeIBAN,
}) => {
  const { t } = useAppTranslation();

  if (pendingIBANs.length === 0) return null;

  return (
    <div>
      <Typography.Text className="tw-mb-5 tw-text-base">{t("profile.bank.pendingAccounts")}</Typography.Text>
      <Space direction="vertical" className="tw-mt-4 tw-w-full" size="middle">
        {pendingIBANs.map((iban) => {
          const statusInfo = getStatusInfo(iban.status);
          const isRejected = iban.status === IBANStatus.REJECTED;
          const isActiveIBAN = activeIBAN === iban.iban;
          return (
            <div key={iban.id}>
              <ShebaCard
                sheba={iban.iban}
                title={iban.title}
                status={isRejected ? "rejected" : "pending"}
                statusText={statusInfo.text}
                errorMessage={iban.errorMessage}
                onDelete={() => handleRemoveIBAN?.(iban.id)}
                onRetry={isRejected ? onRetryRejected : undefined}
                retryLoading={retryRequestLoading}
                showBankPrefix={false}
                hideDeleteIcon
                disableDelete={isActiveIBAN}
                isActiveIBAN={isActiveIBAN}
              />
            </div>
          );
        })}
      </Space>
    </div>
  );
};
